export default "__VITE_ASSET__Db9NQ9o0__"